/**
 * Break-glass: the sign-in / create-account form column inside the
 * get-quotes dialog. A fixed 688px — the same column the standalone
 * /sign-in and /create-account screens use. Not something a layout primitive
 * can express.
 *
 * No photo and no border here, unlike the standalone screens. The dialog is
 * already a bordered card, so the pane's own border read as a second frame
 * inside it; and at any width that leaves the 688px column intact there is
 * nothing left over for a photo to occupy. The dialog takes its width from
 * this column (`width="auto"`), so the two can't disagree.
 */

import type { ReactNode } from "react";

interface BookShipmentAuthenticationPaneProps {
  children: ReactNode;
}

export function BookShipmentAuthenticationPane({
  children,
}: BookShipmentAuthenticationPaneProps) {
  return (
    // Half the vertical padding of the standalone screens, because the dialog
    // adds its own above and below — stacked, the two left a band of empty
    // space between the dialog's close buttons and the logo. Horizontal padding
    // is unchanged, so the form's content width still matches those screens.
    <div className="max-h-[883px] w-[688px] px-16 py-8">{children}</div>
  );
}
